import { render, staticRenderFns } from "./NomenCats.vue?vue&type=template&id=47f40068"
import script from "./NomenCats.vue?vue&type=script&lang=js"
export * from "./NomenCats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports